import { SET_PRICE_LIST } from "./priceListActionTypes"
import PriceList from "./PriceList"

export type PriceListStore = {
    priceLists: Map<string, PriceList>
}

const defaultState: PriceListStore = {
    priceLists: new Map<string, PriceList>()
}


function priceListReducer(state = defaultState, action) {
    switch(action.type) {
    case SET_PRICE_LIST:
        const id = action.payload.priceListId as string
        const priceList = action.payload.priceList as PriceList
        state.priceLists.set(id, priceList)
        return {...state}
    default:
        return state
    }
}

export default priceListReducer



// WEBPACK FOOTER //
// ./src/state/price-list/priceListReducer.ts